import { render } from "./ProfileView.vue?vue&type=template&id=068477c2&scoped=true"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=068477c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068477c2"]])

export default __exports__